import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faScaleBalanced,
  faScroll,
  faWandSparkles,
  faCards,
  faDice,
  faThList,
} from '@fortawesome/pro-light-svg-icons'

export function registerWebIcons(): void {
  library.add(
    faScaleBalanced,
    faScroll,
    faWandSparkles,
    faCards,
    faDice,
    faThList
  )
}
